import { Collapse, Spin, Typography } from "antd";
import React from "react";
import { useNavigate } from "react-router-dom";
import { BOM } from "../../../../../services/definedMethod";
import FeedbackModal from "../../../../treasury/bond/components/FeedbackModal";
import { Util } from "../helpers";
import PreviewTable from "./PreviewTable";

const { Text } = Typography;

const PreviewForm = ({
  formData,
  username,
  prodTemplate,
  customer,
  contractTemplate,
  product,
  contract,
  customerAccounts,
  chargeData,
  currencySymbol,
}) => {
  const navigate = useNavigate();
  console.log(chargeData);
  console.log(formData);
  console.log(prodTemplate);

  const dataSections = [
    {
      header: "Contract Information",
      items: [
        { name: "Customer Name", labelValue: customer?.displayName, type: 1 },
        { name: "Customer ID", labelValue: customer?.accountNo, type: 1 },
        {
          name: "Customer Type",
          labelValue: customer.legalForm?.value,
          type: 1,
        },
        { name: "Customer Branch", labelValue: customer?.officeName, type: 1 },
        { name: "Product Name", labelValue: product?.productName, type: 1 },
        {
          name: "Custodian",
          labelValue: Util.mapFormFieldToLabel(
            "custodians",
            formData?.custodian,
            prodTemplate
          ),
        },
        {
          name: "Account Linked",
          labelValue: Util.mapFieldToAcct(
            "savingsAccounts",
            formData?.linkedAccountId,
            customerAccounts
          ),
        },
        { name: "Initiated By", labelValue: username, type: 1 },
      ],
    },
    {
      header: "Instrument Details",
      items: [
        {
          name: "Instrument",
          labelValue: product?.instrumentType?.name,
        },
        {
          name: "Issuing Authority",
          labelValue: product?.issuer?.name,
        },
        {
          name: "Auction Reference",
          labelValue: formData?.auctionReference,
          type: 1,
        },
        {
          name: "Maturity Tenor",
          labelValue: product?.tenor?.text,
        },
        {
          name: "Issue Date",
          labelValue: BOM.DateTime(formData?.issueDate, "only-date"),
          type: 1,
        },
        {
          name: "Maturity Date",
          labelValue: BOM.DateTime(formData?.maturityDate, "only-date"),
          type: 1,
        },
      ],
    },
    {
      header: "Tax & Charges",
      items: [
        {
          name: "Tax Group",
          type: 3,
          items: [
            {
              labelValue: chargeData?.allowTax ? "Yes" : "No",
            },
            chargeData?.taxGroup?.name
              ? {
                  labelValue: chargeData?.taxGroup?.name,
                }
              : null,
            chargeData?.taxGroup?.taxAssociations
              ? {
                  labelValue: chargeData?.taxGroup?.taxAssociations[0]
                    ?.taxComponent?.percentage
                    ? `%${chargeData?.taxGroup?.taxAssociations[0]?.taxComponent?.percentage?.toLocaleString()}`
                    : "-",
                }
              : null,
          ],
        },
        {
          name: "Processing Charges",
          type: 3,
          items: [
            {
              labelValue: chargeData?.setupCharges ? "Yes" : "No",
            },
            chargeData?.setupCharge?.name
              ? {
                  labelValue: chargeData?.setupCharge?.name,
                }
              : null,
            chargeData?.setupCharge?.taxAssociations
              ? {
                  labelValue: chargeData?.setupCharge?.taxAssociations[0]
                    ?.taxComponent?.percentage
                    ? `${currencySymbol}${chargeData?.setupCharge?.taxAssociations[0]?.taxComponent?.percentage?.toLocaleString()}`
                    : "-",
                }
              : null,
          ],
        },
        {
          name: "Redemption Charges",
          type: 3,
          items: [
            {
              labelValue: chargeData?.redemptionCharges ? "Yes" : "No",
            },
            chargeData?.redemptionCharge?.name
              ? {
                  labelValue: chargeData?.redemptionCharge?.name,
                }
              : null,
            chargeData?.redemptionCharge?.taxAssociations
              ? {
                  labelValue: chargeData?.redemptionCharge?.taxAssociations[0]
                    ?.taxComponent?.percentage
                    ? `${currencySymbol}${chargeData?.redemptionCharge?.taxAssociations[0]?.taxComponent?.percentage?.toLocaleString()}`
                    : "-",
                }
              : null,
          ],
        },
        {
          name: "Stamp Duty Charges",
          type: 3,
          items: [
            {
              labelValue: chargeData?.transferCharges ? "Yes" : "No",
            },
            chargeData?.transferCharge?.name
              ? {
                  labelValue: chargeData?.transferCharge?.name,
                }
              : null,
            chargeData?.transferCharge?.taxAssociations
              ? {
                  labelValue: chargeData?.transferCharge?.taxAssociations[0]
                    ?.taxComponent?.percentage
                    ? `${currencySymbol}${chargeData?.transferCharge?.taxAssociations[0]?.taxComponent?.percentage?.toLocaleString()}`
                    : "-",
                }
              : null,
          ],
        },
        {
          name: "Brokerage/Agent Commission",
          type: 3,
          items: [
            {
              labelValue: chargeData?.allowBrokerage ? "Yes" : "No",
            },
            chargeData?.commission?.name
              ? {
                  labelValue: chargeData?.commission?.name,
                }
              : null,
            chargeData?.commission?.taxAssociations
              ? {
                  labelValue: chargeData?.commission?.taxAssociations[0]
                    ?.taxComponent?.percentage
                    ? `${currencySymbol}${chargeData?.commission?.taxAssociations[0]?.taxComponent?.percentage?.toLocaleString()}`
                    : "-",
                }
              : null,
          ],
        },
      ],
    },
    {
      header: "Investment Details",
      items: [
        {
          name: "Face Value",
          labelValue: Number(formData.faceValue).toLocaleString(),
          type: 1,
        },
        {
          name: "Discount Rate",
          labelValue: `${product?.discountRate} %`,
          type: 1,
        },
        {
          name: "Purchase Price",
          labelValue: Number(formData?.purchasePrice)?.toLocaleString(),
          type: 1,
        },
        {
          name: "Yield",
          labelValue: Number(formData?.yieldPercentage)?.toLocaleString(),
          type: 1,
        },
        {
          name: "Interest Type",
          labelValue: product?.interestType?.text,
        },
        {
          name: "Maturity Value",
          labelValue: Number(formData?.maturityValue)?.toLocaleString(),
          type: 1,
        },
        {
          name: "Settlement Date",
          labelValue: BOM.DateTime(formData?.settlementDate, "only-date"),
          type: 1,
        },
        {
          name: "Value Date",
          labelValue: BOM.DateTime(formData?.valueDate, "only-date"),
          type: 1,
        },
      ],
    },
    {
      header: "Tax & Regulatory",
      items: [
        {
          name: "Central Bank Reporting Code",
          labelValue: formData?.centralBankReportingCode,
          type: 1,
        },

        {
          name: "AML Flag",
          labelValue: Util.mapFormFieldToLabel(
            "amlOptions",
            formData?.amlScreening,
            contractTemplate
          ),
        },

        {
          name: "Withholding Tax Allowed",
          type: 2,
          labelValue: formData?.withholdTax,
        },
        {
          name: "KYC/KYB Validated",
          type: 2,
          labelValue: formData?.kycValidated,
        },
        {
          name: "Central Bank Auction Reference Linked",
          type: 2,
          labelValue: formData?.centralBankAuctionRefLinked,
        },
      ],
    },
    {
      header: "Maturity Settings",
      items: [
        {
          name: "Target Account",
          labelValue: Util.mapFieldToAcct(
            "savingsAccounts",
            formData?.targetAccountId,
            customerAccounts
          ),
        },
        {
          name: "Narration on Maturity",
          labelValue: formData?.maturityNarration,
          type: 1,
        },
        // {
        //   name: "Interest Rate Type",
        //   labelValue: product?.interestRateType?.text ?? "----",
        // },
        {
          name: "Interest Accrual",
          labelValue: Util.mapFormFieldToLabel(
            "interestTypeOptions",
            formData?.interestType,
            contractTemplate
          ),
        },
        {
          name: "Re-investment Option",
          type: 3,
          items: [
            {
              labelValue: formData?.allowRollover ? "Yes" : "No",
            },
            formData.allowRollover
              ? {
                  labelValue:
                    formData?.autoRollover === false ? "Manual" : "Auto",
                }
              : null,
          ],
        },

        {
          name: "Auto Maturity Transfer",
          type: 2,
          labelValue: formData?.autoMaturityTransfer,
        },
      ],
    },
  ];
  const [showSuccessModal, setShowSuccessModal] = React.useState(false);
  const finalData = dataSections.map((item, i) => {
    console.log(item);
    return {
      key: i,
      label: (
        <div style={{}}>
          <Text style={{ fontSize: 16 }}>{item.header}</Text>
        </div>
      ),
      children: <PreviewTable data={item.items} />,
      showArrow: false,
    };
  });

  const handleClose = () => {
    setShowSuccessModal(false);
  };
  function onCancel() {
    navigate("/treasury-bill", { replace: false });
  }
  return (
    <div className="form-section">
      <Spin spinning={false} size="large">
        <h2 style={{ margin: 0, fontSize: "24px" }}>Preview</h2>
        <p style={{ marginTop: "5px", color: "#6b7280" }}>
          Add description text to note for users
        </p>

        {contract && (
          <h2 style={{ fontSize: "16px" }}>
            Contract ID: {contract?.contractReferenceId}
          </h2>
        )}
        <div className="----">
          <Collapse
            bordered={false}
            // expandIcon={<CaretDownIcon />}
            ghost={true}
            style={{ marginTop: 20, padding: 0 }}
            items={finalData}
            defaultActiveKey={[0, 1, 2, 3, 4, 5]}
            className="no-margin"
            // expandIconPosition="right"
          />
        </div>

        <FeedbackModal
          message={
            contract
              ? "Your Contract has been updated successfully."
              : "Your Contract has been updated successfully."
          }
          visible={showSuccessModal}
          type="success"
          onPrimaryAction={() => {
            handleClose();
          }}
          onSecondaryAction={() => {
            onCancel();
          }}
          onClose={handleClose}
        />
      </Spin>
    </div>
  );
};

export default PreviewForm;
